export const TAX_REGISTRATION_TYPE_SELF_EMPLOYED = 'SelfEmployed'
export const TAX_REGISTRATION_TYPE_CIS = 'Cis'
export const TAX_REGISTRATION_TYPE_NON_SELF_EMPLOYED = 'NonSelfEmployed'
export const TAX_REGISTRATION_TYPE_LOST_UTR = 'LostUtr'

export const TAX_REGISTRATION_STATUS_STARTED = 'Started'
export const TAX_REGISTRATION_STATUS_INFORMATION_REQUESTED = 'InformationRequested'
export const TAX_REGISTRATION_STATUS_SUBMITTED = 'Submitted'
export const TAX_REGISTRATION_STATUS_COMPLETE = 'Complete'
export const TAX_REGISTRATION_STATUS_CANCELLED = 'Cancelled'
